module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER 2")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FTER LUNCH")]), _vm._v(",")]), _vm._v(" Diego’s mom jotted him an excuse note and dropped him off at school, telling him, “No more trouble, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He slammed the car door without answering. Couldn’t she understand that he never "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wanted")]), _vm._v(" to cause trouble? He signed in at the attendance office and arrived at his locker just as the bell rang, flooding the hallway with students.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“’Sup?” Kenny smiled, walking up to him. “Glad they didn’t lock you up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He and Diego had been best friends since middle school—bonded by good grades and their shared love for the ocean.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nah, the PO has to do a report first.” Diego bonked Kenny over the head with the mini spyglass, laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What’s this?” Kenny grinned at the telescope and lifted it up to his glasses.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yo, MacMann!” Guerrero called from two lockers down. “So, who’s your PO?”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Guerrero had already been sentenced to probation: for driving his foster dad’s car without a license, crashing it into a telephone pole, and knocking out the power for an entire neighborhood. He talked and acted as if he were Diego’s buddy, but to Diego he was mostly a pain in the ass.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A guy named Vidas,” Diego yelled back.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He’s a fag,” declared Guerrero. To Guerrero, everybody was a fag.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego ignored the comment, his attention caught by a figure across the crowded hallway: Ariel Lamar.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To Diego, she was the most amazing girl at school, maybe even the entire planet. She was beyond cute: radiant, with skin that emanated warmth, and the world’s most perfect breasts. Added to that, she liked tropical fish, the same as he did. He’d seen her at the mall’s pet shop where he worked. But to his regret, he’d passed up two ideal opportunities to talk to her, freezing up each time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She’s smiling at you,” Kenny whispered to Diego.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Nah, she isn’t,” Diego murmured, even though it looked like she was. He felt himself turn red as he smiled back.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“She’s smiling cause she thinks you’re dorky.” Guerrero snickered. But at that moment, even Guerrero’s annoying comments failed to faze Diego.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Why don’t you go and say hi to her?” Kenny suggested.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("As if it were that easy. The mere prospect made Diego break out in a sweat.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("“Go reel her in,” Guerrero taunted, “and bring her back.” Placing both paws on Diego’s shoulders, he launched Diego ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("across the hallway. And as though pulled by the tendrils of Ariel’s long, full lashes, Diego felt himself floating toward her.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Her smile beckoned as though it were a lighthouse. Her green eyes sparkled like sunlight on the ocean. But as Diego almost reached her, a guy wearing khakis and loafers sailed in front of him, cutting him off.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Hey, Ariel,” Preppie Dude greeted her. And even though Ariel peered over the guy’s shoulder, Diego whirled around and raced back to his locker in record-breaking time.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Smooth!” Guerrero grabbed Diego’s arm and play-punched him. “Real smooth!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego shook him off. He didn’t like guys touching him, especially some jerk like Guerrero.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“What happened?” Kenny asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego didn’t want to admit he’d wimped out. “I think she’s got a boyfriend.” It was probably true. How could any girl that spectacular "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" already have a boyfriend?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Well”—Guerrero smirked—“you can always go back to Fabio.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Shut up!” Diego barked, wanting to pound Guerrero, nearly forgetting he’d been in court for assault only hours earlier. Luckily, Kenny pulled him back.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("During the remainder of the school day, Diego tried to concentrate on his classwork and stop thinking about how he’d once again botched up with Ariel. It embarrassed him that at sixteen, he’d never even kissed a girl—although not for lack of interest. He liked girls. A lot. A whole lot.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("In his room alone or while taking a long shower, he’d ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("fantasize about holding a girl in his arms, stroking her hair, kissing her lips…. He’d run his hands tenderly across her breasts and when she wanted more, he’d gladly give it to her. And afterward, she’d lay her head on his chest, happy and satisfied.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("But in real life, if a girl so much as said hi, he choked up. It was hopeless. He felt like a loser.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When he got home that afternoon, he peeled his backpack off and sat at his aquarium, his thoughts swirling about Ariel. Had she really been smiling at him? Could any girl that amazing ever actually be interested in somebody with problems like his?")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He gave his clownfish, Nemo and Gill, a tiny snack of dried krill and then played peekaboo with them through the tank glass. The saltwater fish required more care and attention than freshwater ones, but it was worth it for the hours he spent looking at their brilliant colors, imagining them on a faraway reef. He loved his fish.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A short time later, his eight-year-old brother’s school bus stopped out front. He joined Diego, watching the clown fish dart in and out of the rose-colored anemone. While Eddie jabbered about his school day, Diego mostly just listened and let him talk. He didn’t mention his appearance in court. His mom had told him not to, since his little brother looked up to him so much.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After sitting for a while leaning into each other, the boys started horsing around. Diego had been teaching Eddie to box so he could defend himself if anybody tried to mess with him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Keep your fists up.” Diego taught him like he’d learned from boxers on TV.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Eddie loved the horseplay, giggling as his older brother fought off his punches but ultimately let him triumph.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Since their mom didn’t get home from her night job till after nine, it fell upon Diego to make dinner and help Eddie with homework. Eddie sat at the kitchen table with his schoolbooks, asking Diego questions while Diego boiled noodles, fried ground beef, and heated tomato sauce. Mac had taught him to cook—mostly basic stuff like spaghetti and burgers.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Tonight, after they’d cleaned up the kitchen and put the plates in the dishwasher, Eddie watched TV and Diego went to his room to do his own homework. But the loser feelings about his botch-up with Ariel kept gnawing at him. Leaving his schoolwork aside, he walked to his dresser mirror and examined his reflection.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His hair was thick and black. And his eyes were nearly as dark, just like his mom’s. His cheekbones were high, his jaw square.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re a handsome boy,” Mac had often told him. Diego had wanted to be handsome, but not for Mac. Even now he could almost feel Mac’s hand running through his hair, tousling it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Diego reached inside his shirt and pulled out the elastic cord that hung around his neck. Fastened to it with two bits of wire was one of the first presents Mac had given him: a great white shark’s tooth.")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("At the time, the huge tooth had barely fit into Diego’s five-year-old palm. The triangle measured over two inches wide at the base and was equally long, its jagged edges tapering to a perfect point. Everyone in his neighborhood had wanted to ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("see it, especially the boys. Filled with awe, they ran their fingers across the bone-smooth surface and gingerly tapped the tooth’s razor-fine tip.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The tooth gave Diego a feeling of power and strength. Since the day he first got it, he always kept it on—showering with it, eating with it, sleeping with it. Sometimes he woke at night and carefully ran his hands across it, to make sure the tooth was still there.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("One afternoon shortly after Mac’s suicide, Diego had come home from school with his mind a whirlpool of swirling thoughts and feelings—similar to today. Trying to calm himself, he’d taken hold of the shark’s tooth, as an impulse came over him. He lifted the underside of his forearm, where his skin was lighter-colored, and pressed the tooth’s point against it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was no pain at first. His skin sank beneath the tooth’s pressure. Then he pressed harder. The tip punctured the flesh and a heat spike shot up Diego’s arm. With total clarity, he watched a bright red bead bubble to the skin’s surface.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Slowly, he sliced the tooth’s serrated edge across his flesh like a steak knife. It was only a slight cut, but deep enough for pain to flood his body—a sharp pang that diminished all his other feelings.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A tiny rivulet of blood oozed up from the cut and glistened on his skin like sparkling lights. The entire room suddenly appeared brighter, its colors more clear, every sound more crisp. He ran his fingers across the tingling gash and felt a little proud. He hadn’t shed a single tear.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("A week after that first time, he’d cut himself again. And the next week and the next. The whole area between his wrist and left elbow became crisscrossed with scars. Perpendicular slices. Bisecting angles.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sometimes the pain was excruciating. He knew he shouldn’t be doing it, but he couldn’t stop. He didn’t want to. With each cut he felt a new thrill—a release of some pressure that had built up inside him. He was letting it out.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To staunch the blood, he nabbed Band-Aids, or cotton balls, or gauze pads from the medicine chest. As those supplies ran out, he used toilet paper and Scotch tape, or anything else he could find. When he peeled the bandages off, they sometimes stuck and burned like fire.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He took care not to cut so deep that he’d need stitches, and if a wound began to look infected, he slathered it with antibiotic cream. He didn’t want his mom to find out. The secrecy of the cutting brought back a familiar feeling from when Mac had been alive: once again, Diego had begun to live a double life.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His mom never questioned why he used so many Band-Aids. Perhaps she was too busy working to notice. Or maybe she just didn’t want to know.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("At school, a couple of teachers had spotted the cuts and asked, “What happened?” Diego’s heart raced as he told them the same thing he’d told Eddie: “Just an accident.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Do you want to talk about it?” one teacher persisted, obviously not believing him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“No,” Diego answered. Confessing how crazy he was acting would mean admitting it to himself, too.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“You shouldn’t do that to yourself,” Kenny had said, wincing at the scars. “Doesn’t it hurt?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Yeah.” Diego nodded evasively. “But I like it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I thought only girls cut,” Guerrero had sneered when he noticed the marks.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To avoid attracting any more flak, Diego began to wear only long-sleeve tops—cotton tees mostly, the sleeves of which were pliable enough to pull down below his wrists. When his left arm got full, he started on his right: the excitement of fresh skin. And when his arms filled up, he ventured across his chest. With each cut he felt stronger and more powerful than ever. Like tonight.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("He sliced the tooth across his skin, and for a moment all his confused and painful worries about Ariel, Vidas, his past, and the future disappeared. Somehow, he’d get through it.")])])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c0e278ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416995050_ch02.vue
// module id = 84
// module chunks = 0